import { useState } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useLocalStorage(key: string, initialValue?: any) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = localStorage.getItem(key)
      return item ? item : initialValue
    } catch (error) {
      console.error('Error reading localStorage', error)
      return initialValue
    }
  })

  const setValue = (value: string | null) => {
    try {
      setStoredValue(value)
      localStorage.setItem(key, value || '')
    } catch (error) {
      console.error('Error setting localStorage', error)
    }
  }

  const removeValue = () => {
    try {
      localStorage.removeItem(key)
      setStoredValue(initialValue)
    } catch (error) {
      console.error('Error removing localStorage', error)
    }
  }

  return [storedValue, setValue, removeValue] as const
}

export default useLocalStorage
